import { ButtonColor } from 'component-library/components/buttons/PrimaryButton';
import { colors } from 'component-library/styles/colors';
import { graphql } from 'gatsby';

const COLOR_SCHEMES = {
  [colors.teal]: {
    fontColor: colors.black,
    buttonColor: ButtonColor.Peach,
    backgroundColor: colors.teal,
  },
  [colors.peach]: {
    fontColor: colors.black,
    buttonColor: ButtonColor.Teal,
    backgroundColor: colors.peach,
  },
  [colors.navyBlue]: {
    fontColor: colors.white,
    buttonColor: ButtonColor.Peach,
    backgroundColor: colors.navyBlue,
  },
};

export const getColorScheme = (color?: string | null) => {
  const componentLibraryColor = color
    ? colors[color as keyof typeof colors]
    : colors.teal;

  return COLOR_SCHEMES[componentLibraryColor];
};

export const BlogAdFragment = graphql`
  fragment BlogAd on ContentfulBlogAd {
    title
    buttonCopy
    buttonUrl
    image {
      gatsbyImageData
    }
    showCallNowButton
    backgroundColor
    message {
      message
    }
  }
`;
